import { PrimaryLanguageEnum } from 'domains/client';
import { getAreasByConcernKeys } from 'domains/signupDirect/misc/communicationConcerns';
import { therapyTargetValues } from 'domains/signupDirect/misc/constants';
import { InsuranceDefinitionV2 } from 'domains/signupDirect/misc/insuranceOptions';
import { ClinicalConcerns } from 'domains/signupDirect/schemas/common';
import { StateAbbrev } from 'utils/states';
import { RequiredErrorMessage } from 'utils/validators/zodHelpers';
import { z } from 'zod';

const State = z.string();

const TherapyTarget = z.enum(therapyTargetValues, RequiredErrorMessage);
const LanguageType = z.nativeEnum(PrimaryLanguageEnum, RequiredErrorMessage);

const InsuranceType = z
  .object({})
  .passthrough()
  .transform(d => d as InsuranceDefinitionV2);

export const PaymentMethod = z.discriminatedUnion(
  'type',
  [
    z.object({
      type: z.literal('insurance'),
      insuranceData: InsuranceType,
      id: z.string(),
    }),
    z.object({
      type: z.literal('privatePay'),
      id: z.string(),
    }),
    z.object({
      type: z.literal('otherInsurance'),
      id: z.string(),
    }),
  ],
  { errorMap: () => RequiredErrorMessage },
);

type PaymentMethod = z.infer<typeof PaymentMethod>;
export type InsurancePayment = Extract<PaymentMethod, { type: 'insurance' }>;

const directSignupFiltersSchemaRaw = z.object({
  therapyTarget: TherapyTarget,
  stateCode: State.min(1, RequiredErrorMessage),
  language: LanguageType,
  paymentMethod: PaymentMethod,
  ...ClinicalConcerns.shape,
});

const directSignupFiltersSchema = directSignupFiltersSchemaRaw.transform(d => ({
  ...d,
  clinicalAreas: getAreasByConcernKeys(d.clinicalConcernKeys, d.therapyTarget),
}));

type DirectSignupFiltersFormType = z.infer<typeof directSignupFiltersSchema> & {
  stateCode: StateAbbrev;
};

type SignupPaymentMethod = DirectSignupFiltersFormType['paymentMethod'];

export { directSignupFiltersSchema, type DirectSignupFiltersFormType, type SignupPaymentMethod };
